import { memo } from "react";

const CommentIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12.1953C9.7614 12.1953 12 9.95671 12 7.19531C12 4.43389 9.7614 2.19531 7 2.19531C4.23857 2.19531 2 4.43389 2 7.19531C2 7.99516 2.18781 8.75111 2.52173 9.42156C2.61047 9.59971 2.64 9.80336 2.58856 9.99561L2.29076 11.1087C2.16148 11.5918 2.6035 12.0338 3.08667 11.9046L4.1997 11.6068C4.39197 11.5553 4.59561 11.5849 4.77377 11.6736C5.44419 12.0075 6.20015 12.1953 7 12.1953Z"
        stroke="#777777"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(CommentIcon);
